/**
 * Outputs attribution to browser console
 */
export default function attribution() {
  // eslint-disable-next-line no-console
  console.log(`Copyright © Big Bite ${new Date().getUTCFullYear()}`);
}
